import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, OnInit, Output ,ViewChild} from '@angular/core';
import { Subject } from 'rxjs';
import { PhysicianData } from '../../../../@core/interfaces/masters/physician-mst';
import { FormBuilder, FormGroup, Validators ,FormControl} from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { ServiceData } from '../../../../@core/interfaces/masters/service';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import * as moment from 'moment';
import { DataSecurityService } from '../service/DataSecurityService';
import { DateService } from '../service/date.service';
import { ToastrAppSrvcService } from '../../../../_services/toastr-app-srvc.service';
import { QcReasonMstData } from '../../../../pages/inventory/backend-module/interface/master/qcreason-mst';
import { ReferralQueueComponent } from '../../../../pages/Masters/referral-queue/referral-queue.component';
import { CommonMasterData } from '../../../../@core/interfaces/masters/commonmaster';
@Component({
  selector: 'ngx-admissionreferral',
  templateUrl: './admissionreferral.component.html',
  styleUrls: ['./admissionreferral.component.scss']
})
export class AdmissionreferralComponent implements OnInit {
  @Input() regId: any;
  @Input() visitId: number;
  @Input() admissionId: any;
  @Input() caseSheetViewSummary:any={};
  @Input() editPatApt:any={};
  @Input() visitLog:Array<any>=[];
  @Input() ehrAdvcasesheetTaskId : any
  @Input() rootId: number;
  @Input() isNewCaseSheet : boolean = false
  @Input() visitDoctorid: any;
  isCreate: boolean = true
  isEditComponent: boolean = false;
  isAddComponent: boolean = false;
  isSubmitting = false;
  Successmsg: string
  showtable :boolean = false
  nodatamsg : boolean = true

  private userId = localStorage.getItem("userId");
  get fval() { return this.admissionForm.controls; }
  get apiUrl(): string { return environment.apiUrl; }
  protected readonly unsubscribe$ = new Subject<void>();
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  physType = 'GetAllInternalDoctor'
  admissionForm: FormGroup
  recommendedDate: Date | null = new Date();
  Admissionperiod = [{ id: 1, name: 'Today' },{ id: 2, name: 'Within 2 Days' },{ id: 3, name: 'Within a Week' },{ id: 4, name: 'Within 15 Days' },
    { id: 5, name: 'Within 1 Month' },{ id: 6, name: 'Within 2 Month' },{ id: 7, name: 'Custom' }
  ];
  phlen:number=4000;
  phcharflag:boolean=false;
  valuefield:string=''
  @Input() adminList:Array<any>=[];
  isSubmitted:boolean=false;
  ExtrnalDoctorList:Array<any>=[];
  loadDoc:Array<any>=[];
  admissionReasonList: Array<any> = [];

  period(id:any){
    // const periodData = this.Admissionperiod
    // const filterdata = periodData.filter((x)=>x.id === id)
    if(id != null || id != ''){
      const periodData = this.Admissionperiod
      const filterdata = periodData?.filter((x) => x?.id == id)
      if(filterdata?.length>0){
        return filterdata[0]?.name
      }else{
        return ''
      }
    }else{
      return ''
    }
  }

  customFlag:boolean=false;
  @Output() dataEvent: EventEmitter<any> = new EventEmitter<any>();

  DoctorList: Array<any> = []
  Getalldetails: Array<any> = []
  constructor(private injector: Injector,protected QcReasonMstData: QcReasonMstData,protected DataSecurityOP : DataSecurityService,protected UTCtimeconvert : DateService,protected phySrvc: PhysicianData, protected fb: FormBuilder,private cdr: ChangeDetectorRef ,protected serSrvc: ServiceData, protected rolesService: RolesData,private toaster: ToastrAppSrvcService, protected mstReasonSrv: CommonMasterData) {
    this.admissionForm = this.fb.group({
      Reason: this.fb.control(''),
      Type: this.fb.control('Inhouse'),
      Mode: this.fb.control(false),
      Doctor: this.fb.control('', [Validators.required]),
      Admissionperiod: this.fb.control('',[Validators.required]),
      DateTime: this.fb.control(null,[Validators.required]),
      Scheduled: this.fb.control("New"),
      checkBoxControl:this.fb.control('')
    })
  }

  ngOnInit(): void {
    this.Doctordata()
    this.getall()
    this.DataSecurityOP.Apifunction(this.ehrAdvcasesheetTaskId)
    this.loadAdmissionReasons()
  }

  getall() {
    this.Getalldetails = this.adminList
  }
  
  onAdmissionPeriodChange(selectedPeriod: number): void {
    const currentDate = moment();
    let newDate: Date | null = null;

    switch (selectedPeriod) {
        case 1:
            newDate = currentDate.toDate();
            this.customFlag=false;
            break;
        case 2:
            newDate = currentDate.add(2, 'days').toDate();
            this.customFlag=false;
            break;
        case 3:
            newDate = currentDate.add(7, 'days').toDate();
            this.customFlag=false;
            break;
        case 4:
            newDate = currentDate.add(15, 'days').toDate();
            this.customFlag=false;
            break;
        case 5:
            newDate = currentDate.add(1, 'month').toDate();
            this.customFlag=false;
            break;
        case 6:
            newDate = currentDate.add(2, 'months').toDate();
            this.customFlag=false;
            break;
        case 7:
            newDate = null;
            this.customFlag=true; // Allow manual input or custom behavior
            break;
        default:
            break;
    }
    this.admissionForm.get('DateTime')?.setValue(newDate);
    this.cdr.markForCheck();
}

  Doctordata() {
    this.phySrvc.list(`physicians/${this.tenandId}/${this.branchId}/${this.physType}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.DoctorList = data;
      this.loadDoc = this.DoctorList;
       if (this.visitDoctorid) {
      this.admissionForm.get('Doctor')?.setValue(this.visitDoctorid);
    }
    })
    this.phySrvc.list(`physicians/${this.tenandId}/${this.branchId}/GetAllExternalDoctor`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.ExtrnalDoctorList = data
    })
  }

  loadAdmissionReasons() {
    const url = `tenants/${this.tenandId}/masterreason/${this.branchId}/GetCommonMaster?type=ADMISSION_REASON&isActive=true`;
    this.mstReasonSrv.list(url).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if (data && data.code === 200) {
        this.admissionReasonList = data.details;
      } else {
        this.admissionReasonList = [];
      }
      this.cdr.markForCheck();
    }, error => {
      console.error('Error loading admission reasons', error);
    });
  }
  docSelect(val){
    if(val=='internal')
      this.loadDoc = this.DoctorList
    else if(val == 'external')
      this.loadDoc = this.ExtrnalDoctorList;
  }


  Doctorfillter(data: any) {
    if(data != null){
      const doctordata = this.DoctorList?.filter((x) => x?.id == data)
      return doctordata[0]?.name
    }else{
      return ''
    }

  }
  editId : number
  showAccessMsg:boolean
  isDisableTimeValidation:boolean
  editCreateDate:Date
  editcreatedById:number
  VitalcreatedDate(vitalDate:any){
    const servicedata = this.DataSecurityOP.accessEditDate?.opLockTime ?? 0
    const date = new Date(vitalDate);
    const minutesToAdd = servicedata * 60 * 1000;
    date.setTime(date.getTime() + minutesToAdd)
    return date
  }
timeValidation(date:Date){
  if(!this.DataSecurityOP.InitialAccess){
  if(!this.DataSecurityOP.AdminAccess){
  if(new Date()>= this.VitalcreatedDate(date)){
    this.isDisableTimeValidation = true
    this.showAccessMsg = true
    return true
  }else{
    this.isDisableTimeValidation = false
    this.showAccessMsg = false
    return false
  }
}else{
  this.isDisableTimeValidation = false
  this.showAccessMsg = false
  return false
}
}
this.isDisableTimeValidation = false
this.showAccessMsg = false
return false
}
  callEdit(data: any) {
    this.isSubmitted=false;
    this.admissionForm.controls['Doctor'].reset();
    this.isCreate = false;
    if(data?.Admissionperiod==7){
      this.customFlag=true;
    }
    else{
      this.customFlag=false;
    }
    this.editCreateDate = this.UTCtimeconvert.dateUtctoLocalDateAndTime(data?.createdDate)
    this.editcreatedById = data?.createdBy
    this.timeValidation(this.editCreateDate)
    this.editId = data?.pcId
    this.admissionForm.controls['Reason'].setValue(data?.Reason);
    this.admissionForm.controls['Type'].setValue(data?.Type);
    this.admissionForm.controls['Mode'].setValue(data?.Mode);
    this.admissionForm.controls['Admissionperiod'].setValue(data?.Admissionperiod);
    this.admissionForm.controls['DateTime'].setValue(data?.DateTime);
    this.admissionForm.controls['Scheduled'].setValue("New");
    this.admissionForm.controls['checkBoxControl'].setValue(data?.Insurance);
    this.admissionForm.controls['Doctor'].setValue(data?.Doctor)
    setTimeout(()=>{ 
      if(data?.Type == 'External')
        this.loadDoc = this.ExtrnalDoctorList;
      else
        this.loadDoc = this.DoctorList;
      this.admissionForm.controls['Doctor'].setValue(data?.Doctor);},300)
  }
  

  onEdit(){
    const DocData =this.loadDoc?.find(x => x?.id == this.admissionForm.get('Doctor')?.value) 
    const putvalue = {
      "pcId": this.editId,
      "woId": null,
      "regId": this.regId,
      "ipId": this.admissionId,
      "careTaskType": 13,
      "careTaskPlace": null,
      "careTaskStatus": 4,
      "CreatedDate":  this.editCreateDate,
      "CreatedBy":  this.editcreatedById,
      "UpdatedDate": null,
      "UpdatedBy":  this.userId,
      "TenantId": this.tenandId,
      "BranchId": this.branchId,
      "CreatedIP": null,
      "UpdatedIP": null,
      "inputJson": JSON.stringify({
        Reason: this.admissionForm.get('Reason').value,
        Type: this.admissionForm.get('Type').value,
        Mode: this.admissionForm.get('Mode').value,
        Doctor: this.admissionForm.get('Doctor').value,
        Admissionperiod: this.admissionForm.get('Admissionperiod').value,
        DateTime: this.admissionForm.get('DateTime').value,
        Scheduled: "New",
        Insurance: this.admissionForm.get('checkBoxControl').value,
        oldApp:this.visitLog[0]?.appointmentId,
        refDoc : this.caseSheetViewSummary?.opvisit?.length > 0
        ? this.caseSheetViewSummary?.opvisit[0]?.name
        : this.editPatApt?.department?.name || '-',
        refDep : this.caseSheetViewSummary?.opvisit?.length > 0
        ? this.caseSheetViewSummary?.opvisit[0]?.depname
        : this.editPatApt?.doctor?.displayName || '-',
        docName:DocData?.displayName||'-',
      docid:DocData?.id ||'-',
      depid:DocData?.department?.id ||'-',
      deptName:DocData?.department?.name ||'-'
      }),
      "visitId": this.visitId,
      "SubstatusName":"SecondOpinion-RefAdmission",
      "doctorId":this.admissionForm.get('Doctor').value,
      rootId:this.rootId ? this.rootId:null
    }
    if(this.admissionForm.valid && !this.timeValidation(this.editCreateDate)){
    this.rolesService.update(`${this.apiUrl}/PatientCareTaskMaster/UpdatePatientCareTaskMst/${this.editId}`,putvalue).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.dataEvent.emit(data?.details);
      this.isCreate = true;
      this.admissionForm.reset();
      this.admissionForm.get('Type').setValue('Inhouse');
      this.isSubmitting = false;
      this.Successmsg = "Data Updated Successfully"
      this.customFlag=false;
     this.toaster.ForSuccess(this.Successmsg)
      this.phcharflag=false;
      this.phlen=4000;
      this.loadDoc = this.DoctorList;
      if(this.isNewCaseSheet) this.getCounsellings();
      const dashboardInstance = this.injector.get(ReferralQueueComponent);
      dashboardInstance?.closeReferPopup();
    },
    (error: any) => {
      this.isSubmitting = false;
      this.toaster.ForDanger('Please Fill Mandatory Fields');
    }
    )    
    }else{
      this.timeValidation(this.editCreateDate)
      this.isSubmitting = false;
      this.toaster.ForDanger('Please Fill Mandatory Fields');
    }
  }
  onSave() {
    if (this.isSubmitting) return; 
    this.isSubmitting = true;
    this.isSubmitted=true;
    const DocData =this.loadDoc?.find(x => x?.id == this.admissionForm.get('Doctor')?.value) 
    const postdata = {
      "woId": null,
      "regId": this.regId,
      "ipId": this.admissionId,
      "careTaskType": 13,
      "careTaskPlace": null,
      "careTaskStatus": 4,
      "CreatedDate": new Date(),
      "CreatedBy": this.userId,
      "UpdatedDate": null,
      "UpdatedBy": null,
      "TenantId": this.tenandId,
      "BranchId": this.branchId,
      "CreatedIP": null,
      "UpdatedIP": null,
      "inputJson": JSON.stringify({
        Reason: this.admissionForm.get('Reason').value,
        Type: this.admissionForm.get('Type').value,
        Mode: this.admissionForm.get('Mode').value,
        Doctor: this.admissionForm.get('Doctor').value,
        Admissionperiod: this.admissionForm.get('Admissionperiod').value,
        DateTime: this.admissionForm.get('DateTime').value,
        Scheduled: "New",
      Insurance:this.admissionForm.get('checkBoxControl').value,
      oldApp:this.visitLog[0]?.appointmentId,
      refDoc : this.caseSheetViewSummary?.opvisit?.length > 0
      ? this.caseSheetViewSummary?.opvisit[0]?.name
      : this.editPatApt?.department?.name || '-',
       refDep : this.caseSheetViewSummary?.opvisit?.length > 0
      ? this.caseSheetViewSummary?.opvisit[0]?.depname
      : this.editPatApt?.doctor?.displayName || '-',
      docName:DocData?.displayName||'-',
      docid:DocData?.id ||'-',
      depid:DocData?.department?.id ||'-',
      deptName:DocData?.department?.name ||'-'
      }),
      "visitId": this.visitId,
      "SubstatusName": "SecondOpinion-RefAdmission",
      "doctorId":this.admissionForm.get('Doctor').value,
      rootId:this.rootId ? this.rootId:null
    }
    if(this.admissionForm.valid){
    this.rolesService.create(`${this.apiUrl}/PatientCareTaskMaster/PostPatientCareTaskMst`, postdata).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      const details = data.details;
      this.admissionForm.reset();
      this.admissionForm.get('Type').setValue('Inhouse');
      this.dataEvent.emit(data?.details);      
      this.isSubmitting = false;
      this.customFlag=false;
      this.Successmsg = "Data saved Successfully"
      this.toaster.ForSuccess(this.Successmsg)
      this.phcharflag=false;
      this.phlen=4000;
      this.isSubmitted=false;
      this.loadDoc = this.DoctorList;
      if(this.isNewCaseSheet) this.getCounsellings();

      const dashboardInstance = this.injector.get(ReferralQueueComponent);
      dashboardInstance?.closeReferPopup();
    },
    (error: any) => {
      this.isSubmitting = false;
      this.toaster.ForDanger('Please Fill Mandatory Fields');
    }
  )}  else{
    this.isSubmitting = false;
    this.toaster.ForDanger('Please Fill Mandatory Fields');
   
  }
}
  clear() {
    this.customFlag=false;
    this.admissionForm.reset();
    this.admissionForm.get('Type').setValue('Inhouse');
    this.phcharflag = false;
    this.phlen=4000;
    this.loadDoc = this.DoctorList;
  }

   NotesTypevalueChanges(value) {
    if (value != null && value != ''){
      this.phcharflag = true;
      this.phlen = 4000 - value.length;
    }
  }

  getCounsellings() {
    this.QcReasonMstData.list(`PatientCareTaskMaster/GetPatientCareTaskMaster?tenantId=${this.tenandId}&branchId=${this.branchId}&visitId=${this.visitId}`
    ).subscribe((data: any) => {
        const det = data?.details?.map(item => {
          if(!!item?.inputJson){
          item.inputJson = JSON.parse(item?.inputJson);
          item.inputJson.pcId = item?.pcId;
          item.inputJson.careTaskType = item?.careTaskType;
          item.inputJson.careTaskStatus = item?.careTaskStatus;
          item.inputJson.createdDate = item?.createdDate;
          item.inputJson.createdBy = item?.createdBy;
          return item.inputJson;}
          else{
            return item.inputJson;
          }
        });
        this.Getalldetails = det?.filter(x => x?.careTaskType ==13);

        });  
  }

}
